/* eslint-disable */
import axios from 'axios';
import SendBird from 'sendbird';
const pify = require('pify');

class SendBirdService {

  constructor() {
    this.sendBirdService = new SendBird({ appId: process.env.REACT_APP_SENDBIRD_API_KEY });
    console.log(`created sendbird: ` + process.env.REACT_APP_SENDBIRD_API_KEY);

    this.removeSendbirdChannelHandler = this.removeSendbirdChannelHandler.bind(this);
    this.connectSendbirdUser = this.connectSendbirdUser.bind(this);
    this.swapSendbirdConnectUserResponse = this.swapSendbirdConnectUserResponse.bind(this);
    this.createSendbirdChannel = this.createSendbirdChannel.bind(this);
    this.swapSendbirdCreateChannelResponse = this.swapSendbirdCreateChannelResponse.bind(this);
    this.fetchSendbirdChannel = this.fetchSendbirdChannel.bind(this);
    this.swapFetchSendbirdChannelResponse = this.swapFetchSendbirdChannelResponse.bind(this);
    this.sendSendbirdMessage = this.sendSendbirdMessage.bind(this);
    this.swapSendSendbirdSendMessageResponse = this.swapSendSendbirdSendMessageResponse.bind(this);
    this.loadSendbirdMessages = this.loadSendbirdMessages.bind(this);
    this.swapLoadSendbirdMessagesResponse = this.swapLoadSendbirdMessagesResponse.bind(this);
    this.getSendbirdService = this.getSendbirdService.bind(this);
  }

  getSendbirdService() {
    return this.sendBirdService;
  }

  removeSendbirdChannelHandler(discussionId) {
    this.sendBirdService.removeChannelHandler(discussionId);
  }

  connectSendbirdUser(userId) {
    // Create a promise-based version of the connect Sendbird callback function
    return pify(this.swapSendbirdConnectUserResponse)(userId)
      .then(response => {
        return response;
      });
  }

  // Sendbird returns response and error the wrong way round
  swapSendbirdConnectUserResponse(userId, callback) {
    this.sendBirdService.connect(userId, function(user, error) {
      if (user) { callback(null, user); }
      else { callback(error, null); }
    });
  }

  createSendbirdChannel(sendbirdMembers) {
    // Create a promise-based version of the connect Sendbird callback function
    return pify(this.swapSendbirdCreateChannelResponse)(sendbirdMembers)
      .then(response => {
        return response.url;
      });
  }

  // Sendbird returns response and error the wrong way round
  swapSendbirdCreateChannelResponse(sendbirdMembers, callback) {
    this.sendBirdService.GroupChannel.createChannelWithUserIds(sendbirdMembers, false, 'APPROPRIATE-CHANNEL-NAME', 'coverURL', {}, function(channel, error) {
      if (channel) { callback(null, channel); }
      else { callback(error, null); }
    });
  }

  fetchSendbirdChannel(channelURL) {
    // Create a promise-based version of the connect Sendbird callback function
    return pify(this.swapFetchSendbirdChannelResponse)(channelURL)
      .then(response => {
        return response;
      });
  }

  swapFetchSendbirdChannelResponse(channelURL, callback) {
    this.sendBirdService.GroupChannel.getChannel(channelURL, function (channel, error) {
      if (channel) { callback(null, channel); }
      else { callback(error, null); }
    });
  }

  sendSendbirdMessage(channel, message, metaData) {

    // Create a promise-based version of the load message Sendbird callback function
    return pify(this.swapSendSendbirdSendMessageResponse)(channel, message, metaData)
      .then(response => {
        return response;
      });
  }

  swapSendSendbirdSendMessageResponse(channel, message, metaData, callback) {

    const data = JSON.stringify(metaData);
    channel.sendUserMessage(message, data, 'Message', function(message, error){
      if (message) {
        callback(null, message);
      } else {
        callback(error, null);
      }
    });
  }

  removeSendbirdMessage(channelURL, messageId) {

    const endpoint = `https://api.sendbird.com/v3/group_channels/${channelURL}/messages/${messageId}`;
    const payload = {};
    const headers = {
      'Content-Type': 'application/json'
    };

    return axios.delete(endpoint, payload, headers)
      .then(response => {
        return response;
      });
  }

  loadSendbirdMessages(messageListQuery, channel) {

    // Create a promise-based version of the load message Sendbird callback function
    return pify(this.swapLoadSendbirdMessagesResponse)(messageListQuery, channel)
      .then(response => {
        return response;
      });
  }

  swapLoadSendbirdMessagesResponse(messageListQuery, channel, callback) {

    messageListQuery.load(100, true, function (messageList, error) {
      if (messageList) {
        const reversedMessageList = messageList.reverse();
        callback(null, reversedMessageList);
      } else {
        callback(error, null);
      }
    });
  }
}

export let sendBirdService = new SendBirdService();



/** WEBPACK FOOTER **
 ** ./src/utils/sendbird-service.js
 **/